import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.addUser || initialState;

export const selectCompanyDetails = createSelector(
  [selectDomain],
  (state) => state.companyDetails
);
export const selectCompanyBillingAddreses = createSelector(
  [selectDomain],
  (state) => state.billingAddresses
);

export const selectCompanyPickupAddreses = createSelector(
  [selectDomain],
  (state) => state.pickupAddresses
);
export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);
